export const formatTemplateTypeString = (templateType: string) => {
  if (templateType === 'word_group_category') {
    return 'Word Group Category';
  } else if (templateType === 'word_group') {
    return 'Word Group';
  } else if (templateType === 'category_combo') {
    return 'Category Combo';
  }
};
